import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import Globalize from 'globalize';
import $ from 'jquery';
import {getCurrentLocale} from '../store/regional-settings-store';

$(() => {
    const langs = {
        ru() {
            require('jquery-validation/dist/localization/messages_ru');
        },
        en() {},
    };

    const locale = getCurrentLocale();
    if (langs[locale]) {
        langs[locale]();
    }
});

export function validate(form, element) {
    $(form).validate().element(element);
}

function parseNumber(value) {
    let parsedValue = Globalize.parseNumber(value);
    if (isNaN(parsedValue)) {
        parsedValue = parseFloat(value.replace(/,/g, ''));
    }

    return parsedValue;
}

// code below is partially get from jquery-validation-globalize-fix
const originalMethods = {
    min: $.validator.methods.min,
    max: $.validator.methods.max,
    range: $.validator.methods.range,
};

$.validator.methods.dateGlobalizeOptions = {dateParseFormat: {skeleton: 'yMd'}};

$.validator.methods.date = function(value, element) {
    const val = Globalize.parseDate(value, $.validator.methods.dateGlobalizeOptions.dateParseFormat);
    return this.optional(element) || (val instanceof Date);
};

$.validator.methods.number = function(value, element) {
    const val = parseNumber(value);
    return this.optional(element) || ($.isNumeric(val));
};

$.validator.methods.min = function(value, element, param) {
    const val = parseNumber(value);
    return originalMethods.min.call(this, val, element, param);
};

$.validator.methods.max = function(value, element, param) {
    const val = parseNumber(value);
    return originalMethods.max.call(this, val, element, param);
};

$.validator.methods.range = function(value, element, param) {
    const val = parseNumber(value);
    return originalMethods.range.call(this, val, element, param);
};
